export default __webpack_public_path__ + "static/body-v2-01-neck-957dc723f7db406abcc760a3fab923c8.png";